import AppToast from "@toothfairy/shared-ui/AppToast";
import React from "react";
import { useTranslation } from "react-i18next";
import useWorkspaces from "../../../Hooks/useWorkspaces";
import ChartingSettingsView from "../Components/ChartingSettingsView";
import workspacesHelper from "../../../API/Workspaces/workspacesHelper";

const ChartingSettingsContainer = () => {
  const { getActiveWorkspace } = useWorkspaces();
  const { t } = useTranslation();
  const AppToasty = AppToast.useToast();
  const handleSubmit = async (v) => {
    console.log("v", v);
    try {
      const result = await workspacesHelper.updateWorkspace(
        getActiveWorkspace().id,
        [
          {
            property: "customChartingConfig",
            value: JSON.stringify(v),
          },
        ]
      );

      AppToasty.show(t("toasts.chartingPaletteUpdated"), {
        type: "success",
      });
    } catch (e) {
      console.log("e", e);
      AppToasty.show(t("toasts.chartingPaletteUpdateFailed"), {
        type: "danger",
      });
    }
  };

  return <ChartingSettingsView onSubmit={handleSubmit} />;
};

export default ChartingSettingsContainer;
